import { createApiClient } from '@shared/api-client/index';

// The api origin (no version): each operation path carries its own /v1 prefix, and
// the WS gateway lives at the origin root (/socket.io). The SSR serverApi (loaders)
// uses this same origin.
export const apiOrigin = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

export const api = createApiClient(apiOrigin);
